import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './WelcomeDialog.css';

const INVALID_CHARS = /[\\/:*?"<>|]/;

const WelcomeDialog = ({ show, authorName, onNewDiagram, onLoadDiagram }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (show) {
      setName('');
      setError('');
      setTimeout(() => inputRef.current?.focus(), 200);
    }
  }, [show]);

  if (!show) return null;

  const validate = (value) => {
    if (!value.trim()) return '';          // empty is OK — just disables button
    if (INVALID_CHARS.test(value)) return String.raw`Ungültige Zeichen: \ / : * ? " < > |`;
    if (value.trim().length > 100) return 'Name darf maximal 100 Zeichen lang sein.';
    return '';
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setName(val);
    setError(validate(val));
  };

  const handleCreate = (e) => {
    e.preventDefault();
    const err = validate(name);
    if (err || !name.trim()) {
      if (err) setError(err);
      return;
    }
    onNewDiagram(name.trim());
  };

  const isCreateDisabled = !name.trim() || !!error;

  return (
    <div className="welcome-overlay">
      <div className="welcome-dialog">
        <div className="welcome-header">
          <i className="bi bi-diagram-3-fill welcome-logo"></i>
          <div>
            <h4 className="welcome-title">BPMN Editor</h4>
            <p className="welcome-greeting">Willkommen, {authorName}!</p>
          </div>
        </div>

        <div className="welcome-body">
          <form className="welcome-row" onSubmit={handleCreate}>
            <input
              id="welcome-name-input"
              ref={inputRef}
              type="text"
              className="welcome-input"
              value={name}
              onChange={handleChange}
              placeholder="Prozessname"
              autoComplete="off"
            />
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              disabled={isCreateDisabled}
            >
              <i className="bi bi-file-earmark-plus"></i> Neu
            </button>
          </form>
          {error && <div className="welcome-error">{error}</div>}
          <button
            type="button"
            className="btn btn-secondary btn-sm welcome-load-btn"
            onClick={onLoadDiagram}
          >
            <i className="bi bi-folder2-open"></i> Vorhandenes BPMN laden
          </button>
        </div>
      </div>
    </div>
  );
};

WelcomeDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  authorName: PropTypes.string.isRequired,
  onNewDiagram: PropTypes.func.isRequired,
  onLoadDiagram: PropTypes.func.isRequired,
};

export default WelcomeDialog;
